/* eslint-disable */
export default {
  saveLog: '保存',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
